import { OrkiszewskiFlowRegime } from ".";
import type { PipeFrictionContext } from "../d";
import type { PipeFrictionIntermediates } from "..";

export function calculateGradientsTransition(
  tubingFrictionContext: PipeFrictionContext,
  mistFlowFrictionGradient: number,
  mistFlowStaticGradient: number
): PipeFrictionIntermediates {
  const {
    fluidPropertiesContext: {
      fluidProperties: {
        gasSuperficialVelocityFTSEC,
        gasDensityLBMFT3,
        liquidSuperficialVelocityFTSEC,
        liquidDensityLBMFT3,
        gasOilRatioSCFSTB
      }
    }
  } = tubingFrictionContext;

  // D329 =(D310+D302)/(1-(D63*D155+D62*D154)*(D154/D18))
  const totalGradient =
    (mistFlowStaticGradient + mistFlowFrictionGradient) /
    (1 -
      (liquidDensityLBMFT3 * liquidSuperficialVelocityFTSEC +
        gasDensityLBMFT3 * gasSuperficialVelocityFTSEC) *
        (gasSuperficialVelocityFTSEC / gasOilRatioSCFSTB));

  // ORK TRANSITION FLOW ONLY CALCULATES TOTAL FRICTION PRESSURE, NOT COMPONENT PARTS
  // D335: =D329*D3*SIN(D8)
  // const staticAndFrictionPressurePSIA = totalGradient * hydrostaticSum;

  return {
    flowRegime: OrkiszewskiFlowRegime.TRANSITION,
    frictionPressurePSIA: 0,
    totalGradient
  };
}
